/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:45:28
 * @LastEditTime: 2024-07-05 10:03:59
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-data-query\modules\fullFlowDataRouter.js
 * 全流向数据路由
 */
const fullFlowDataRouter = [
  // 历史销售数据查询
  {
    path: '/flowSystem/flow-history',
    name: 'flowSystemFlowHistory',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/masterDataSystem/yanan/FlowHistory'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/historical-sales-data/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '历史销售数据查询'
    }
  },
  // 历史销售数据 导入
  {
    path: '/flowSystem/flow-history-import',
    name: 'flowSystemFlowHistoryImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem3" */
      //   '../views/masterDataSystem/yanan/FlowHistoryImport'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/historical-sales-data/Import.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '历史销售数据导入',
      breadcrumb: [
        {
          title: '历史销售数据查询',
          name: 'flowSystemFlowHistory'
        }
      ]
    }
  },
  // 销售数据查询PendingInFlow.vue
  {
    path: '/flowSystem/sales-data',
    name: 'flowSystemSalesData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/SalesData.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemSalesData" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '销售数据查询'
    }
  },
  // 销售数据查询批量更新
  {
    path: '/flowSystem/sales-data/batch-update/:meta_type',
    name: 'flowSystemSalesDataBatchUpdate',
    component: () => 
      import(
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/BatchUpdate.vue'
      ), 
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '销售数据查询'
    }
  },
  // 流向对接
  {
    path: '/flowSystem/sales-data/flow-abutment',
    name: 'SalesDataFlowAbutment',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/SalesData.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemSalesData" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/flow-abutment/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '流向对接',
      breadcrumb: [
        {
          title: '销售数据查询',
          name: 'flowSystemSalesData'
        }
      ]
    }
  },

  // 销售数据查询中的标签更新
  {
    path: '/flowSystem/sales-data/update-tag',
    name: 'flowSystemSalesDataUpdateTag',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemSalesData" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/UpdateTag.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '标签更新',
      breadcrumb: [
        {
          title: '销售数据查询',
          name: 'flowSystemSalesData'
        }
      ]
    }
  },

  // 销售数据导入 按导入人查看
  {
    path: '/flowSystem/sales-data-importer',
    name: 'flowSystemSalesDataByImporter',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '../views/flowSystem/SalesDataByImporter.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/ViewbyImporter.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '按导入人查看',
      breadcrumb: [
        {
          title: '销售数据查询',
          name: 'flowSystemSalesData'
        }
      ]
    }
  },
  //  销售数据导入 导入流向标签数据
  {
    path: '/flowSystem/flow-tag-importer',
    name: 'flowImporterTag',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '@/views/flowSystem/flowImporterTag.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/ImportFlowLabel.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '导入流向标签数据',
      breadcrumb: [
        {
          title: '销售数据查询',
          name: 'flowSystemSalesData'
        }
      ]
    }
  },
  // 销售数据查询 > 历史组织架构
  {
    path: '/flowSystem/history-organization-examine-xs/:type',
    name: 'flowSystemHistoryOrganizationExamineXs',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem3" */
      //   '../views/flowSystem/historyOrganizationExamineXs.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/HistoricalOrganStruct'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '销售数据查询-历史组织架构',
      breadcrumb: [
        {
          title: '销售数据查询',
          name: 'flowSystemSalesData'
        }
      ]
    }
  },
  // 销售数据查询 > 重洗销量归属
  {
    path: '/flowSystem/reload-clear',
    name: 'flowSystemReloadClear',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem3" */
      //   '../views/flowSystem/dataHandling/ReloadClear.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/ReWashVolume'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '重洗销量归属',
      breadcrumb: [
        {
          title: '销售数据查询',
          name: 'flowSystemSalesData'
        }
      ]
    }
  },
  // 销售数据查询 > 重洗销量归属 已入库数据明细
  {
    path: '/flowSystem/incoming-data-detail/:id',
    name: 'flowSystemIncomingDataDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/dataHandling/IncomingDataDetail.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/sales-data/StockDataDetail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '已入库数据明细',
      breadcrumb: [
        {
          title: '销售数据查询',
          name: 'flowSystemSalesData'
        },
        {
          title: '重洗销量归属',
          name: 'flowSystemReloadClear'
        }
      ]
    }
  },
  // 采购数据查询
  {
    path: '/flowSystem/purchase-data',
    name: 'flowSystemPurchaseData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem3" */
      //   '../views/flowSystem/PurchaseData.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/purchas-data/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '采购数据查询'
    }
  },
  // 库存数据查询SalesData.vue
  {
    path: '/flowSystem/repertory-data',
    name: 'flowSystemRepertoryData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem3" */
      //   '../views/flowSystem/RepertoryData.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/inventory-data/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '库存数据查询'
    }
  },
  // 服务商关联流向
  {
    path: '/flowSystem/Service-flow-data',
    name: 'flowSystem-Service-flow-data',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/ServiceFlowData.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystem-Service-flow-data" */
        '@/views/butterfly-flow-system/flow-direction-data-query/full-flow-data/service-relate-flow/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '全流向数据', //二级菜单
      title: '服务商关联流向'
    }
  }
]
export default fullFlowDataRouter
